import React from 'react';
import $ from 'jquery';
import moment from 'moment';
import 'moment-timezone';
import 'datatables';
import 'datatables/media/css/jquery.dataTables.css'
import config from './config'
import axios        from 'axios'

export default class DeploymentTable extends React.Component {
  componentDidMount() {
    this.$table.DataTable({'paging': false}).column(config.COLUMNS.STATUS).search('').draw()
  }

  deleteServerDeployment(serverDeploymentId) {
    axios.delete(config.GRAPH.ENDPOINT + serverDeploymentId + config.GRAPH.VERSION).catch(error => console.log()).then(resp => {
      window.location.reload(); 
    })
  }

  transformByteToGiga(byte) {
    return Math.round(byte / 1024 / 1024 / 1024)
  }

  serverInRedState(deploymentServer) {
    var hdFreeSpace = (deploymentServer.server && deploymentServer.server.meta.disk && this.transformByteToGiga(deploymentServer.server.meta.disk.free) < 20) || (!deploymentServer.server || !deploymentServer.server.meta.disk || !deploymentServer.server.meta.disk.free)
    var health = deploymentServer.meta && deploymentServer.meta.health === 'False'
    var reload = (deploymentServer.meta && deploymentServer.meta.reload === 'False') || (!deploymentServer.meta || !deploymentServer.meta.reload)
    var dateUpdated = Date.parse(deploymentServer.dateUpdated + ' UTC')
    var now = new Date().getTime()
    var date = now - dateUpdated > 120 * 60 * 1000

    return hdFreeSpace || health || reload || date
  }

  render() {
    const logoDelete = require('./assets/delete.png');
    var {data} = this.props;
    const checkedShowRedServer = this.props.checkedShowRedServer
    const detSetId = this.props.detSetId
    const detSetService = this.props.detSetService
    const status = this.props.status
    const deploymentCompany = this.props.deploymentCompany
    var domain = "https://" + window.location.hostname

    if(checkedShowRedServer) {
      data = data.filter((e,i) => this.serverInRedState(e))
    }
    if(checkedShowRedServer && data.length === 0) {
      return null
    } else {
      return (
        <div id="all">
          <h2><a href={domain + "/backoffice/admin/detectionSettings/" + detSetId}>{detSetId + " " + detSetService}</a></h2>
          <b>Companies: </b> {deploymentCompany.map(c => <a href={"https://my.visua.com/backoffice/admin/companys/" + c.id}>{c.id + "-" + c.name}, </a>)}
          <br/>
          Status: <input type="checkbox" checked={status === 1}/>
          <table 
            ref={(table) => { this.$table = $(table); }}
            className="tbl dataTable" width="100%">
            <thead>
              <tr className="titre">
                <th>Hostname</th>
                <th>Platform</th>
                <th>Status</th>
                <th>Branch</th>
                <th>Private IP</th>
                <th>Public IP</th>
                <th>CPU</th>
                <th>Freq</th>
                <th>RAM free</th>
                <th>RAM used</th>
                <th>RAM total</th>
                <th>HDD free</th>
                <th>HDD total</th>
                <th>Health</th>
                <th>Reload</th>
                <th>Updated (UTC)</th>
                <th>Delete</th>
              </tr>
            </thead>
            <tbody>
              {data.map((deploymentServer, i) => (<tr key={deploymentServer.server.id} className= 
              {(() => {
                var className = i % 2 ? 'odd ' : 'even '
                if(deploymentServer.dateUpdated) {
                  var dateUpdated = moment.utc(deploymentServer.dateUpdated)
                  var now = moment.utc()
                  if(now.diff(dateUpdated) > 120 * 60 * 1000) { // two hours
                    className += 'Error'
                  }
                }
                return className
              })()
              }>
                <td>{deploymentServer.server ? deploymentServer.server.hostname: ""}</td>
                <td>{deploymentServer.server ? deploymentServer.server.meta.platform: ""}</td>
                <td>{deploymentServer.server ? deploymentServer.server.meta.status: ""}</td>
                <td>{deploymentServer.server ? (deploymentServer.server.meta.gitBranch || "<none>") : ""}</td>
                <td>{deploymentServer.server ? (deploymentServer.server.meta.privateIp || "<none>") : ""}</td>
                <td>{deploymentServer.server ? (deploymentServer.server.meta.publicIp || "<none>") : ""}</td>
                <td>{deploymentServer.server ? (deploymentServer.server.meta.cpu ? deploymentServer.server.meta.cpu.toFixed(0) : "<none>"): ""}</td>
                <td>{deploymentServer.server.meta && deploymentServer.server.meta.freq && deploymentServer.server.meta.freq.prc ? deploymentServer.server.meta.freq.prc.toFixed(0) : "<none>"}</td>
                <td>{(() => {
                  if(deploymentServer.server && deploymentServer.server.meta.ram) {
                    return this.transformByteToGiga(deploymentServer.server.meta.ram.free)
                  } else {
                    return "<none>"
                  }
                })()}</td>
                <td>{(() => {
                  if(deploymentServer.server && deploymentServer.server.meta.ram) {
                    return this.transformByteToGiga(deploymentServer.server.meta.ram.used)
                  } else {
                    return "<none>"
                  }
                })()}</td>
                <td>{(() => {
                  if(deploymentServer.server && deploymentServer.server.meta.ram) {
                    return this.transformByteToGiga(deploymentServer.server.meta.ram.total)
                  } else {
                    return "<none>"
                  }
                })()}</td>
                <td className = 
                {(() => {
                  if(deploymentServer.server && deploymentServer.server.meta.disk && this.transformByteToGiga(deploymentServer.server.meta.disk.free) < 20) {
                    return 'error'
                  } else if(!deploymentServer.server || !deploymentServer.server.meta.disk || !deploymentServer.server.meta.disk.free) {
                    return 'warning'
                  }
                })()
                }>{(() => {
                  if(deploymentServer.server && deploymentServer.server.meta.disk) {
                    return this.transformByteToGiga(deploymentServer.server.meta.disk.free)
                  } else {
                    return "<none>"
                  }
                })()}</td>
                <td>{(() => {
                  if(deploymentServer.server && deploymentServer.server.meta.disk) {
                    return this.transformByteToGiga(deploymentServer.server.meta.disk.total)
                  } else {
                    return "<none>"
                  }
                })()}</td>
                <td className = 
                {(() => {
                  if(deploymentServer.meta && deploymentServer.meta.health === 'False') {
                    return 'error'
                  } else if(!deploymentServer.meta || !deploymentServer.meta.health) {
                    return 'warning'
                  }
                })()
                }>{deploymentServer.meta ? deploymentServer.meta.health : "<none>"}</td>
                <td className = 
                {(() => {
                  if(deploymentServer.meta && deploymentServer.meta.reload === 'False') {
                    return 'error'
                  } else if(!deploymentServer.meta || !deploymentServer.meta.reload) {
                    return 'warning'
                  }
                })()
                }>{deploymentServer.meta ? deploymentServer.meta.reload : "<none>"}</td>                
                <td>{moment(deploymentServer.dateUpdated).format('DD-MM-YYYY HH:mm')}</td>
                <td><img alt="delete" src={String(logoDelete)} onClick={() => this.deleteServerDeployment(deploymentServer.id)} className="pointer"/></td>
              </tr>))}
            </tbody>
          </table>
          <br/><br/><br/>
        </div>
      );
    }
  }
}


// WEBPACK FOOTER //
// ./src/DeploymentTable.js